import { baseApi } from "@/core/api/baseApi";
import type {
  Role,
  CreateRolePayload,
  UpdateRolePayload,
} from "../../domain/entities/RolesPermissions";
import type {
  RoleDTO,
} from "../../domain/dto/RolesPermissionsDTO";
import { mapRolesDTO, mapRoleByIdDTO } from "./mapper";

export const rolesApi = baseApi.injectEndpoints({
  endpoints: (builder) => ({
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    getPermissions: builder.query<any, void>({
      query: () => "/roles-permissions/permissions",
      // eslint-disable-next-line @typescript-eslint/no-explicit-any
      transformResponse: (response: any) => {
        console.log("API Response:", response);

        return response.data?.categories ?? []; // ✅ FIXED
      },

      providesTags: ["Permissions"],
    }),

    getRoles: builder.query<Role[], void>({
      query: () => "/roles-permissions/roles",
      transformResponse: (response: {
        data: { current_role?: RoleDTO; created_roles: RoleDTO[] };
      }) => {
        const { current_role, created_roles = [] } = response.data ?? {};
        const roles = current_role
          ? [current_role, ...created_roles]
          : created_roles;
        return mapRolesDTO(roles);
      },
      providesTags: ["Roles"],
    }),

    getRoleById: builder.query<Role, string>({
      query: (roleId) => `/roles-permissions/roles/${roleId}`,
      // eslint-disable-next-line @typescript-eslint/no-explicit-any
      transformResponse: (response: { data: any }) =>
        mapRoleByIdDTO(response.data?.role ?? response.data),
      providesTags: (_result, _error, roleId) => [{ type: "Roles", id: roleId }],
    }),

    createRole: builder.mutation<Role, CreateRolePayload>({
      query: (body) => ({
        url: "/roles-permissions/roles",
        method: "POST",
        body,
      }),
      invalidatesTags: ["Roles"],
    }),

    updateRole: builder.mutation<Role, { roleId: string } & UpdateRolePayload>({
      query: ({ roleId, ...body }) => ({
        url: `/roles-permissions/roles/${roleId}`,
        method: "PUT",
        body,
      }),
      invalidatesTags: (_result, _error, { roleId }) => [
        "Roles",
        { type: "Roles", id: roleId },
      ],
    }),

    deleteRole: builder.mutation<void, string>({
      query: (roleId) => ({
        url: `/roles-permissions/roles/${roleId}`,
        method: "DELETE",
      }),
      invalidatesTags: ["Roles"],
    }),
  }),
});

export const {
  useGetPermissionsQuery,
  useGetRolesQuery,
  useGetRoleByIdQuery,
  useCreateRoleMutation,
  useUpdateRoleMutation,
  useDeleteRoleMutation,
} = rolesApi;
